<cm-display-html class="step-description" [content]="step.description"></cm-display-html>
<div class="step-section">
    <h3 class="step-section-title">Details</h3>
    <p class="entries">
        <span class="entries__label"> {{ getComplianceCriteriaType() }} required:</span>
        {{ step.content.number_required || 0 }}
    </p>
    <p class="entries">
        <span class="entries__label"> {{ getComplianceCriteriaType() }} completed:</span>
        {{ step.content.number_completed || 0 }}
    </p>
    <p class="entries" *ngIf="!step.content.allowMultipleEntries">
        <span class="entries__label"> {{ getComplianceCriteriaType() }} remaining:</span> {{ criteriaRemaining || 0 }}
    </p>
</div>
